<template>
  <div class="current-subscription">
    <div class="action-header">
      <div class="action-header__title">
        Manage your subscription
      </div>
    </div>
    <div class="subs-body container">
      <div class="row">
      </div>
      <div class="row">
        <div class="col-5"><b>Current plan:</b></div>
        <div class="col-7">{{ name }} ({{ plan_description }})</div>
      </div>
        <div class="row">
            <div class="col-5"><b>Clicks usage:</b></div>
            <div class="col-7">{{current_count_clicks}} clicks</div>
        </div>
      <div class="row">
        <div class="col-5"><b>Price plan:</b></div>
        <div class="col-7">${{ cost }} per {{ interval }}</div>
      </div>
      <div v-if="grace_period && payment_attached" class="row">
        <div class="col-12">
          <br>
          Your plan will be canceled on <span style="color: red; font-weight: bold ">{{ current_period_end }}</span>,
          but it will still be available until then.
          <br>
        </div>
      </div>
      <div v-if="on_trial && !grace_period && payment_attached" class="row">
        <div class="col-12">
          <br>
          After your free trial ends on {{ current_period_end }}, this plan will continue automatically using
          {{ card_brand }} **** {{ last4 }}
          <br>
        </div>
      </div>
      <div v-if="!payment_attached" class="row">
        <div class="col-12">
          <br>
          Please update your payment method if you wish to continue using PPC Shield after {{ current_period_end }}
          <br>
        </div>
      </div>
      <div v-if="recurring && !on_trial && payment_attached" class="row">
        <div class="col-12">
          <br>
          Your plan renews on {{ current_period_end }} using {{ card_brand }} **** {{ last4 }}
          <br>
        </div>
      </div>
      <div class="row mt-3 top-margin">
        <form class="col w-100" method="POST" action="/stripe/billingPortal">
          <button class="btn btn-primary w-100 change-plan" v-if="payment_attached && !grace_period" type="submit">CHANGE PLAN</button>
          <button class="btn btn-primary w-100 add-payment " v-if="!payment_attached" type="submit">ADD PAYMENT METHOD</button>
          <button class="btn btn-primary w-100 renew-plan " v-if="grace_period && payment_attached" type="submit">RENEW PLAN</button>
          <div class="btn btn-danger mt-3 w-100" v-if="!cancelled" @click="show('cancellation-warning')">CANCEL SUBSCRIPTION
          </div>
        </form>
      </div>
    </div>
    <modal :height="'auto'" :width="'400px'" name="cancel-modal" :clickToClose="false">
      <div class="informative-modal flex flex-col">
        <div class="header">
          Cancel your plan
        </div>

        <div class="body">
          Your plan will be canceled, but is still available until the end of your billing period on
          {{ current_period_end }}<br> <br>
          Please let us know why you are cancelling your subscription before you do so in order to improve our service.
          <br> <br>
          <custom-input
              name="reasons"
              type="select"
              v-model="cancelReason"
              value_name="label"
              label="Reason for cancellation"
              :select_options="reason_list"
              :errors="errors"
          ></custom-input>

          <textarea class="main-form__field select-input" name="reason_other" rows="5" cols="50" placeholder="Details of the cancellation reason"
                    v-model="otherCancelReason">
            </textarea>

          <div v-if="error_text" style="color: #ff0000; margin-bottom: 13px">
            {{ error_text }}
          </div>

          <div v-if="spinner" class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <div class="footer flex justify-end space-x-2">
          <button class="btn" @click="hide('cancel-modal')">CANCEL</button>
          <button class="btn" :disabled="spinner" @click="validateReason">CONFIRM</button>
        </div>
      </div>
    </modal>

    <modal :height="'auto'" :width="'550px'" name="cancellation-warning" :clickToClose="false">
      <div class="informative-modal flex flex-col">
          <div class="header">
              Warning!
          </div>
          <div class="body">
              ⚠️ After you cancel the subscription your Google Ads account will become susceptible to many different fraud threats. With PPC Shield, you can avoid future click fraud attacks.
          </div>
          <div class="footer flex justify-content-end space-x-2">
              <button class="btn default red mr-2" @click="hide('cancellation-warning'); show('cancel-modal');">ACCEPT RISK</button>
              <button class="btn btn-primary" @click="hide('cancellation-warning')">STAY PROTECTED</button>
          </div>
      </div>
    </modal>

    <modal :height="'auto'" :width="'400px'" name="cancellation-confirmation" :clickToClose="false">
      <div class="informative-modal flex flex-col">
        <div class="header">
          Subscription canceled
        </div>

        <div class="body">
          Your plan will be canceled, but is still available until the {{ current_period_end }}
        </div>

        <div class="footer flex justify-end space-x-2">
          <button class="btn" @click="reloadPage()">CLOSE</button>
        </div>

      </div>
    </modal>
  </div>

</template>
<style lang="scss">
.current-subscription {

  .select-dialog-body, .select-options {
    max-height: 250px;
  }

  .btn.btn-danger {
    background-color: #ff5252;
    border-color: #ff5252;
  }

  .top-margin {
    margin-top: 30px!important;
  }

  .ml-2 {
    margin-left: 0 !important;
  }

  .radio-buttons {
    padding-top: 4px;
  }

  textarea {
    width: 100%;
    height: 7rem;
    color: #545454;
    padding: 9px;
  }
  .renew-plan{
    background-color: #38c172;
    border-color: #38c172;
  }
}
</style>
<script>
export default {
  name: 'show-current-subscription',
  props: ['name', 'cost', 'interval', 'renews_on', 'clicks', 'plan_description', 'cancel_on', 'cancel_reasons', 'current_period_end', 'last4', 'on_trial', 'card_brand', 'recurring', 'grace_period', 'payment_attached', 'cancelled', 'current_count_clicks'],
  data: function () {
    return {
      cancelReason: '',
      otherCancelReason: '',
      error_text: '',
      renderComponent: true,
      spinner: false
    }
  },
  computed: {
    s_clicks() {
      return String(this.clicks).replace(/(.)(?=(\d{3})+$)/g, '$1,');
    },
    reason_list() {
      return this.getReasonList();
    }
  },
  methods: {
    getReasonList() {
      let reasonAr = this.cancel_reasons.split("^")
      let reasonSel = [];
      for (let reason in reasonAr) {
        let reasonString = reasonAr[reason].split("|");
        if (reasonString[1])
          reasonSel.push({'key': reasonString[0], 'label': reasonString[1]})
      }
      return reasonSel
    },
    validateReason() {
      this.spinner = true;
      axios.post('/stripe/validateReason', {
        'reason': this.cancelReason.key,
        'otherReason': this.otherCancelReason
      })
          .then(info => {
            this.error_text = '';
            this.show('cancellation-confirmation');
            this.hide('cancel-modal');
            this.recurring = false;
          })
          .catch(err => {
            this.spinner = false;
            if (err.response.data && err.response.data.errors && Object.values(err.response.data.errors).length > 0) {
              this.error_text = Object.values(err.response.data.errors)[0][0];
            }
          });
    },
    show(modalWindow) {
      this.$modal.show(modalWindow);
    },
    hide(modalWindow) {
      this.$modal.hide(modalWindow);
    },
    reloadPage() {
      window.location.reload();
    },
    forceRender() {
      this.renderComponent = false;
      setTimeout(() => {
        this.renderComponent = true;
      }, 200);
      this.cancelReason = '';
      this.otherCancelReason = '';
    }
  },
  mounted() {

  }
}
</script>
